export function isNeedToShowEntityProfileBuildingItemIcons() {
  return true
}
